import { Typography } from '@alice-financial/pretext-ui'
import * as React from 'react'
import { PageBody } from '../../routes/PageBody'
import { useOrg } from '../organization/useOrg'
import { BillingInfo } from './BillingHealthcheck'

export const BillingPage = () => {
  const org = useOrg()
  if (!org) return null
  return (
    <PageBody maxWidth="md">
      <Typography variant="h1" gutterBottom>
        Billing
      </Typography>
      <Typography variant="body2" gutterBottom maxWidth="sm">
        Manage your organization&apos;s billing settings, payment methods, and view invoices. You can pay by
        credit card or ACH using your bank account and routing numbers.
      </Typography>

      <BillingInfo org={org} />
    </PageBody>
  )
}
